module.exports = __webpack_public_path__ + "static/logo-d70b067587f28e0bff01823bb9a948ac.svg";